// BSV CHANGES
import {call, put, takeLatest} from 'redux-saga/effects';
import {NetworkService, ToasterService} from '@app/services';
import {
  getJfwRequest,
  getJfwSuccess,
  getJfwFailure,
  postJfwRequest,
  postJfwSuccess,
  postJfwFailure,
  deleteJfwRequest,
  deleteJfwSuccess,
  deleteJfwFailure,
} from './slice';
import {API_PATH} from '@app/common/constants';
import {ToastType} from '@app/services/toaster';

function* handleGetJfw(action: ReturnType<typeof getJfwRequest>): any {
  try {
    const {searchText} = action.payload || {};
    const url = API_PATH.jfw.getJfwAPI;
    const params = searchText ? {searchText} : {};

    const response: {data: any} = yield call(
      () => NetworkService.get(url, params, {}), 
    );

    console.log(response, url);
    yield put(getJfwSuccess(response.data));
  } catch (error: any) {
    console.error('Distance API Error:', error);
    yield put(getJfwFailure(error.message));
  }
}

function* handlePostJfw(action: ReturnType<typeof postJfwRequest>): any {
  try {
    const url = API_PATH.jfw.postJfwAPI;
    const response: any = yield call(NetworkService.post, url, action.payload);
    if(response.status === 409) {
      yield put(postJfwFailure(response?.data?.details[0].message || ''));
      ToasterService.showToaster(
        response?.data?.details[0].message || 'Error while adding user.',
        ToastType.ERROR,
      );
    }
    else{
      yield put(postJfwSuccess());
      ToasterService.showToaster('User added successfully.', ToastType.SUCCESS);
    }
  } catch (error: any) {
    yield put(postJfwFailure(error.message));
    ToasterService.showToaster(
      error?.response?.data?.title || 'Error while adding user.',
      ToastType.ERROR,
    );
  }
}

function* handleDeleteJfw(action: ReturnType<typeof deleteJfwRequest>): any {
  try {
    const { id } = action.payload;
    const url = `${API_PATH.jfw.deleteJfwAPI}/${id}`;
    const response = yield call(NetworkService.put, url, action.payload);
    if(response.status === 409) {
      ToasterService.showToaster(
        response?.data || 'Error while adding user.',
        ToastType.ERROR,
      );
    }
    else{
      yield put(deleteJfwSuccess());
      ToasterService.showToaster('User added successfully.', ToastType.SUCCESS);
      yield put(getJfwRequest({}));
    }
  } catch (error: any) {
    yield put(deleteJfwFailure(error.message));
    ToasterService.showToaster(
      error?.response?.data?.title || 'Error while deactivating user.',
      ToastType.ERROR
    );
  }
}

export default function* jfwSaga() {
  console.log(getJfwRequest.type, 'getJfwRequest.type');
  yield takeLatest(getJfwRequest.type, handleGetJfw);
  yield takeLatest(postJfwRequest.type, handlePostJfw);
  yield takeLatest(deleteJfwRequest.type, handleDeleteJfw);
}
